import { Component, OnInit } from '@angular/core';

// Services
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-menu-desktop',
  templateUrl: './menu-desktop.component.html',
  styleUrls: ['./menu-desktop.component.sass']
})
export class MenuDesktopComponent implements OnInit {

  closingSesion: boolean = false;

  constructor(
    private _amplitudeService: AmplitudeService,
    private _profileService: ProfileService,
    private _sharedService: SharedService
  ) { }

  ngOnInit(): void {
  }

  async closeSession() {
    this._amplitudeService.emmiterLogEvent('CLOSE_SESSION', {});
    this.closingSesion = true;
    let response: any = await this._profileService.closeSesion().toPromise()
    .catch((err: any) => {
      this.closingSesion = false;
      this.clearData();
      console.log(err);
    });
    this.closingSesion = false;
    if( response  ){
      this.clearData();
    }
  }

  clearData(): void {
    this._sharedService.closeSession()
    location.href = '/';
  }

}
